"use client";

import { c as _c } from "react/compiler-runtime";
import { useFilter } from "@/components/filters/filter-context";
import { Button } from "@/components/ui/button";
export function ResetFiltersButton() {
  const $ = _c(3);
  const {
    resetAllFilters
  } = useFilter();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <span>Restablecer</span>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== resetAllFilters) {
    t1 = <Button onClick={resetAllFilters} variant="secondary" size="sm" className="w-5/12">{t0}</Button>;
    $[1] = resetAllFilters;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}